export default "__VITE_ASSET__7484945e__"